import { render } from "./MemberProfileView.vue?vue&type=template&id=5d4b1e57&scoped=true"
import script from "./MemberProfileView.vue?vue&type=script&lang=js"
export * from "./MemberProfileView.vue?vue&type=script&lang=js"

import "./MemberProfileView.vue?vue&type=style&index=0&id=5d4b1e57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4b1e57"]])

export default __exports__